'use client'

import { Button } from '@/components/ui/button'
import { Mail, ArrowLeft } from 'lucide-react'

interface PasswordResetFormProps {
  isLoading: boolean
  resetEmail: string
  resetSent: boolean
  loginError: string
  setResetEmail: (email: string) => void
  setShowResetForm: (show: boolean) => void
  setResetSent: (sent: boolean) => void
  setLoginError: (error: string) => void
  handlePasswordReset: (e: React.FormEvent) => void
}

export function PasswordResetForm({
  isLoading,
  resetEmail,
  resetSent,
  loginError,
  setResetEmail,
  setShowResetForm,
  setResetSent,
  setLoginError,
  handlePasswordReset,
}: PasswordResetFormProps) {
  return (
    <div className="space-y-4">
      <button
        type="button"
        onClick={() => {
          setShowResetForm(false)
          setResetSent(false)
          setLoginError('')
        }}
        className="flex items-center text-sm text-muted-foreground hover:text-label mb-4"
      >
        <ArrowLeft className="w-4 h-4 mr-1" />
        ログインに戻る
      </button>

      {resetSent ? (
        <div className="text-center py-6">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Mail className="w-8 h-8 text-green-600" />
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">メールを送信しました</h3>
          <p className="text-sm text-muted-foreground">
            {resetEmail} にパスワードリセットのリンクを送信しました。
            <br />
            メールをご確認ください。
          </p>
        </div>
      ) : (
        <form onSubmit={handlePasswordReset} className="space-y-4">
          <h3 className="text-lg font-medium text-gray-900 text-center mb-4">
            パスワードをリセット
          </h3>
          <p className="text-sm text-muted-foreground text-center mb-4">
            登録したメールアドレスを入力してください。
            <br />
            パスワードリセットのリンクをお送りします。
          </p>
          <div>
            <label className="text-sm font-medium text-label mb-1 block">
              メールアドレス
            </label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-subtle" />
              <input
                type="email"
                value={resetEmail}
                onChange={(e) => setResetEmail(e.target.value)}
                placeholder="example@g-house.osaka.jp"
                className="w-full h-12 pl-10 pr-4 border border-border rounded-xl focus:outline-none focus:ring-2 focus:ring-info focus:border-transparent transition-all"
                required
              />
            </div>
          </div>

          {loginError && <p className="text-sm text-red-500 text-center">{loginError}</p>}

          <Button
            type="submit"
            disabled={isLoading}
            className="w-full h-12 bg-[var(--g-green)] hover:opacity-90 text-white font-medium rounded-xl transition-all duration-300"
          >
            {isLoading ? (
              <div className="flex items-center justify-center">
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2" />
                送信中...
              </div>
            ) : (
              'リセットリンクを送信'
            )}
          </Button>
        </form>
      )}
    </div>
  )
}
